
import { useState, useEffect } from 'react';
import { getAppLogoUrl } from '@/utils/storage';

export const LOGO_STORAGE_KEY = 'app-logo';
export const LOGO_UPDATED_EVENT = 'logo-updated';

export function useLogos() {
  const [appLogo, setAppLogo] = useState<string | null>(null);
  const [churchLogo, setChurchLogo] = useState<string | null>(null);
  const [updateCounter, setUpdateCounter] = useState(0);

  useEffect(() => {
    // Load logos from centralized system and localStorage
    const loadLogos = () => {
      try {
        // First priority: centralized app logo
        const centralizedLogo = getAppLogoUrl();
        setAppLogo(centralizedLogo);
        
        // Load saved custom logos from localStorage if any
        const savedAppLogo = localStorage.getItem(LOGO_STORAGE_KEY);
        const savedChurchLogo = localStorage.getItem('church-logo');
        
        // Override with custom logos if they exist
        if (savedAppLogo) {
          setAppLogo(savedAppLogo);
        }
        
        if (savedChurchLogo) {
          setChurchLogo(savedChurchLogo);
        }
      } catch (error) {
        console.error('Error loading logos:', error);
        // Fallback to centralized logo
        setAppLogo(getAppLogoUrl());
      }
    };

    loadLogos();

    // Listen for logo updates
    const handleLogoUpdate = () => {
      loadLogos();
      setUpdateCounter(prev => prev + 1);
    };

    window.addEventListener(LOGO_UPDATED_EVENT, handleLogoUpdate);
    window.addEventListener('storage', (e) => {
      if (e.key === LOGO_STORAGE_KEY || e.key === 'church-logo') {
        handleLogoUpdate();
      }
    });

    return () => {
      window.removeEventListener(LOGO_UPDATED_EVENT, handleLogoUpdate);
      window.removeEventListener('storage', handleLogoUpdate);
    };
  }, []);

  return {
    appLogo,
    churchLogo,
    updateCounter
  };
}
